import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GoogleAttributeFull } from '../attribute-interface';

@Component({
  selector: 'forms-attributes-input',
  templateUrl: './attributes-input.component.html',
  styleUrls: ['./attributes-input.component.scss'],
  standalone: false,
})
export class AttributesInputComponent {
  readonly form = input<FormGroup>();
  readonly orderedInputAttributes = input<GoogleAttributeFull[]>();
  readonly cleared = output<string>();

  hasControl(name: string): boolean {
    return !!this.form().controls[name];
  }

  getControl(name: string): FormControl {
    return this.form().controls[name] as FormControl;
  }

  getFormGroup(name: string): FormGroup {
    return this.form().controls[name] as FormGroup;
  }

  clearAttribute(name) {
    this.cleared.emit(name);
  }
}
